import { Fragment, ReactNode } from "react";
import NavBar from "./NavBar";
import ChatWidget from '../../features/chatbot/components/ChatWidget';

interface MainLayoutProps {
  children: ReactNode;
}

/**
 * Main layout wrapper that includes NavBar and adds proper spacing
 * to prevent content from overlapping with the hamburger menu button.
 */
function MainLayout({ children }: MainLayoutProps) {
  return (
    <Fragment>
      <NavBar />
      <div className="pt-14 sm:pt-16">
        {children}
      </div>
      <ChatWidget />
    </Fragment>
  );
}

export default MainLayout;
